import type { ResponseType } from '@/types/common';
import type { IssueFieldComponent } from '@/types/issue';
import httpUtil from '@/utils/http';
export * from './project';

const request = httpUtil.accurate.request;
const prefix = 'v1/project';

export const issueComponentsApi = {
  /**
   * @description 获取问题模块
   */
  getList(params: { project: number | number[] }): ResponseType<IssueFieldComponent[]> {
    return request({
      url: prefix + '/components',
      method: 'GET',
      params,
    });
  },

  /**
   * @description 创建问题模块
   */
  create(data: any): ResponseType {
    return request({
      url: prefix + '/component',
      method: 'POST',
      data,
    });
  },

  /**
   * @description 更新问题模块
   */
  update(id: number, data: any): ResponseType {
    return request({
      url: prefix + '/component/' + id,
      method: 'PUT',
      data,
    });
  },

  /**
   * @description 删除问题模块
   */
  del(id: number): ResponseType {
    return request({
      url: prefix + '/component/' + id,
      method: 'DELETE',
    });
  },
};
